/**
 * hscroll-slider measures its own scrollable width once, on connectedCallback.
 * If that happens while it's sitting inside a closed <dialog> (width: 0), it
 * concludes there's nothing to scroll and never shows the "next" arrow —
 * only a later window resize or scroll event triggers a re-measure.
 *
 * coretex-dialog dispatches a "dialog:opened" event once it actually opens
 * (dialog.showModal()), so we use that as the trigger to force every
 * hscroll-slider to recompute now that it has real dimensions.
 */
(function () {
  document.addEventListener('dialog:opened', function () {
    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  });
})();
